import { scrubUrl } from "../auth/scrub";

const SENSITIVE_KEY_PATTERN =
  /(password|secret|authorization|api[_-]?key|access_token|refresh_token|^token$|^code$|^state$|^ticket$)/i;

const REDACTED = "[REDACTED]";

function sanitizeUrlLikeString(value: string): string {
  return scrubUrl(value);
}

function sanitizeUnknown(value: unknown): unknown {
  if (value == null) {
    return value;
  }

  if (Array.isArray(value)) {
    return value.map(item => sanitizeUnknown(item));
  }

  if (typeof value === "string") {
    return sanitizeUrlLikeString(value);
  }

  if (typeof value !== "object") {
    return value;
  }

  const record = value as Record<string, unknown>;
  const result: Record<string, unknown> = {};

  for (const [key, entry] of Object.entries(record)) {
    if (SENSITIVE_KEY_PATTERN.test(key)) {
      result[key] = REDACTED;
      continue;
    }

    result[key] = sanitizeUnknown(entry);
  }

  return result;
}

export function sanitizeEventProps<T extends Record<string, unknown>>(
  props: T,
): T {
  return sanitizeUnknown(props) as T;
}

export function sanitizeErrorReason(reason: unknown): string {
  if (typeof reason === "string") {
    return reason.slice(0, 300);
  }

  if (reason instanceof Error) {
    return sanitizeUrlLikeString(reason.message).slice(0, 300);
  }

  return "Unknown error";
}
